import { render, staticRenderFns } from "./IndexUserDataAvg.vue?vue&type=template&id=bcc41968&scoped=true&"
import script from "./IndexUserDataAvg.vue?vue&type=script&lang=js&"
export * from "./IndexUserDataAvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc41968",
  null
  
)

export default component.exports